<script lang="ts">
	import { IconButton } from '@Shelly/shelly-design-system';
	import { home_data } from 'src/stores/account/user';
	import { save_home } from '../../helpers/home_helpers';

	const updateHomeData = () => {
		// const homeDataLayout = $home_data.showNewsletter || {};
		save_home('alexaIntegrationPrompt', {
			seen: false,
		});

		home_data.set({
			...$home_data,
			alexaIntegrationPrompt: {
				seen: false,
			},
		});
	};
</script>

<IconButton class="mr-s" icon="fa-brands fa-amazon" on:click={updateHomeData}
	>Reset Alexa Pop-up</IconButton
>
